import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { API } from "./shared";

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      onLogin(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="font-serif text-3xl text-brand-text">
            Afro <span className="text-brand-gold">Magic</span>
          </h1>
          <p className="font-sans text-sm text-brand-text-muted mt-2">Admin Dashboard</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-4" data-testid="admin-login-form">
          <Input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Admin email"
            data-testid="admin-email-input"
            className="bg-brand-surface border-brand-border text-brand-text placeholder:text-brand-text-muted/50 rounded-none"
          />
          <div className="relative">
            <Input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              data-testid="admin-password-input"
              className="bg-brand-surface border-brand-border text-brand-text placeholder:text-brand-text-muted/50 rounded-none pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              data-testid="toggle-password-visibility"
              className="absolute right-3 top-1/2 -translate-y-1/2 text-brand-text-muted hover:text-brand-gold transition-colors"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-btn"
            className="w-full py-3 bg-brand-gold text-black font-sans font-semibold text-sm hover:bg-brand-gold-light transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
